import React, {useState} from 'react';
import {useSelector} from "react-redux";
import {
    bbDoesCustomerHaveAccessToSubscription,
    bbFormattedDateString,
    isCurrentUserMemberOf
} from "../../../util/bbHelpers";
import AlertDialog from "./PopupAlert";
import {Link, useLocation} from "react-router-dom";
import BBExternalLink from "../accents/BBExternalLink";
import Backdrop from "@material-ui/core/Backdrop";
import {Box, Paper} from "@material-ui/core";
import {makeStyles} from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";

const useStyles = makeStyles(theme => ({
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
        backdropFilter: `blur(7px)`,
    },
    child: {
        filter: `blur(7px)`,
        // backdropFilter: `blur(7px)`,
        pointerEvents: "none",
    },
    paper: {
        // position: 'fixed',
        // top:0,
        // left:0,
        // right:0,
        // bottom:0,
        // width: 600,
        minWidth: 400,
        maxWidth: 800,
        // backgroundColor: theme.palette.background.paper,
        // border: '2px solid #000',
        // boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 6, 4),
    },
}));

const SimpleBackdrop = ({children, }) => {

    const location = useLocation();
    const classes = useStyles();

    const {customerInView, customers} = useSelector(({customer}) => customer);
    const authUser = useSelector(({auth}) => auth.authUser);
    const customer = customers ? customers[customerInView] : null;

    const hasBusinessSubscriptionAccess = bbDoesCustomerHaveAccessToSubscription(customer, 2);
    const hasPortfolioSubscriptionAccess = bbDoesCustomerHaveAccessToSubscription(customer, 1);
    const hasAnySubscriptionAccess = ( customer && customer["Subscription Active"]) || hasPortfolioSubscriptionAccess || hasBusinessSubscriptionAccess;

    const hasSubscriptionForPage = location.pathname.includes("Portfolio")
        ? hasPortfolioSubscriptionAccess
        : location.pathname.includes("Business")
            ? hasBusinessSubscriptionAccess
            : hasAnySubscriptionAccess

    const isAdmin = isCurrentUserMemberOf(authUser,"admin");
    const hasBRBusinessRole = isCurrentUserMemberOf(authUser,"breachrisk")
    const hasBRPortfolioRole  = isCurrentUserMemberOf(authUser,"breachrisk_portfolio")

    const hasRoleForPage = location.pathname.includes("Portfolio")
        ? hasBRPortfolioRole
        : location.pathname.includes("Business")
            ? hasBRBusinessRole
            : hasAnySubscriptionAccess

    const [open, setOpen] = useState(true);

    const handleClose = () => {
        setOpen(false);
    };


    if(isAdmin) {
        return <AlertDialog
            title={"Subscription Not Active"}
            description={`You have access because you are an admin, but the subscription for ${customer.CustomerName} is not active. It was scheduled to end on ${bbFormattedDateString(customer["Subscription EndDate"], "medium")} and was last active on ${bbFormattedDateString(customer["Subscription Last Active"], "medium")}.`}
            customerId={customerInView}
            />
    } else if (!hasSubscriptionForPage) {
        return (
            <Box>
                <div>
                    <Backdrop className={classes.backdrop} open={open} >
                        <Paper className={"p-3"} style={{ textAlign: "center", backdropFilter: `blur(7px)`, }}>

                            <div className={classes.paper}>
                                <h2 className={"text-center"}>
                                    {location.pathname.includes("Portfolio")
                                        ? "BreachRisk™ Portfolio Expired or Inactive"
                                        : location.pathname.includes("Business")
                                            ? "BreachRisk™ for Business Subscription Expired or Inactive"
                                            :"Subscription Expired or Inactive"
                                    }</h2>
                                <p id="transition-modal-description">
                                    {`It appears that your company's access to ${location.pathname.includes("Portfolio") ? "BreachRisk™ Portfolio" : location.pathname.includes("Business") ? "BreachRisk™ for Business" : "this service" } has expired or been deactivated.`}
                                </p>
                                <p id="transition-modal-description">Please contact <BBExternalLink tipText={"Send an email to BreachBits support."} href={`mailto:support@breachbits.com?subject=${customer && customer.CustomerName} Subscription Expired Help`}>support@breachbits.com</BBExternalLink> to report a problem or &nbsp;
                                    <strong style={{textDecoration: "underline"}}>
                                        <Link to={'/board/settings/subscription'}>update your subscription.</Link>
                                    </strong>
                                </p>

                                {location.pathname.includes("Portfolio") && hasBusinessSubscriptionAccess
                                    ? <h3 style={{textDecoration: "underline"}}>
                                        <Link to={"/board/BreachRisk/Business/Score"}>
                                            Go To BreachRisk for Business
                                        </Link>
                                    </h3>
                                    : location.pathname.includes("Business") && hasPortfolioSubscriptionAccess
                                        ? <h3 style={{textDecoration: "underline"}}>
                                            <Link to={"/board/BreachRisk/Portfolio/Insights"}>
                                                Go To BreachRisk Portfolio
                                            </Link>
                                        </h3>
                                        : <h3>
                                            <BBExternalLink tipText={"Send an email to BreachBits support."} href={`mailto:support@breachbits.com?subject=${customer && customer.CustomerName} Subscription Expired Help`}>Contact Support</BBExternalLink>
                                        </h3>
                                }
                                {/*<h3 id="transition-modal-description">*/}
                                {/*    You may still have access to archived data, but be aware that data will only be accurate as of the last time the subscription was active.*/}
                                {/*</h3>*/}
                                {location.pathname.includes("Portfolio") || location.pathname.includes("Business")
                                    ? null
                                    : <Button className="float-right" onClick={handleClose} color="primary">
                                    Ok
                                </Button>}
                            </div>
                        </Paper>
                    </Backdrop>
                        <div className={classes.child}>
                            {children}
                        </div>


                </div>

            </Box>
        );
    } else if (!hasRoleForPage){
        return(
            <Box>
                <div>
                    <Backdrop className={classes.backdrop} open={open} >
                        <Paper className={"p-3"} style={{ textAlign: "center", backdropFilter: `blur(7px)`, }}>

                            <div className={classes.paper}>
                                <h2 className={"text-center"}>
                                    {location.pathname.includes("Portfolio")
                                        ? "You Do Not Have Access To BreachRisk™ Portfolio"
                                        : location.pathname.includes("Business")
                                            ? "You Do Not Have Access To BreachRisk™ for Business"
                                            :"Subscription Expired or Inactive"
                                    }</h2>
                                <p id="transition-modal-description">
                                    {`Your user permissions do not include access to ${location.pathname.includes("Portfolio") ? "BreachRisk™ Portfolio" : location.pathname.includes("Business") ? "BreachRisk™ for Business" : "this service" }.`}
                                </p>
                                <p id="transition-modal-description">Please contact the administrator for your BreachRisk™ account if you believe this is an error.
                                </p>

                                {location.pathname.includes("Portfolio") && hasBusinessSubscriptionAccess && hasBRBusinessRole
                                    ? <h3 style={{textDecoration: "underline"}}>
                                        <Link to={"/board/BreachRisk/Business/Score"}>
                                            Go To BreachRisk for Business
                                        </Link>
                                    </h3>
                                    : location.pathname.includes("Business") && hasPortfolioSubscriptionAccess && hasBRPortfolioRole
                                        ? <h3 style={{textDecoration: "underline"}}>
                                            <Link to={"/board/BreachRisk/Portfolio/Insights"}>
                                                Go To BreachRisk Portfolio
                                            </Link>
                                        </h3>
                                        : <h3>
                                            <BBExternalLink tipText={"Send an email to BreachBits support."} href={`mailto:support@breachbits.com?subject=${customer && customer.CustomerName} Subscription Expired Help`}>Contact Support</BBExternalLink>
                                        </h3>
                                }
                                {/*<h3 id="transition-modal-description">*/}
                                {/*    You may still have access to archived data, but be aware that data will only be accurate as of the last time the subscription was active.*/}
                                {/*</h3>*/}
                                {location.pathname.includes("Portfolio") || location.pathname.includes("Business")
                                    ? null
                                    : <Button className="float-right" onClick={handleClose} color="primary">
                                        Ok
                                    </Button>}
                            </div>
                        </Paper>
                    </Backdrop>
                    <div className={classes.child}>
                        {children}
                    </div>


                </div>

            </Box>
        )
    }

}
export default SimpleBackdrop;


// <AlertDialog
//     title={
//     <h2 className={"text-center"}>
//         {location.pathname.includes("Portfolio")
//             ? "BreachRisk™ Portfolio Expired or Inactive"
//             : location.pathname.includes("Business")
//             ? "BreachRisk™ for Business Subscription Expired or Inactive"
//                 :"Subscription Expired or Inactive"
//         }</h2>}
//     description={<div className={"text-center p-3"}>
//         <p id="transition-modal-description">
//             {`It appears that your company's access to ${location.pathname.includes("Portfolio") ? "BreachRisk™ Portfolio" : location.pathname.includes("Business") ? "BreachRisk™ for Business" : "this service" } has expired or been deactivated.`}
//         </p>
//         <p id="transition-modal-description">Please contact <BBExternalLink tipText={"Send an email to BreachBits support."} href={`mailto:support@breachbits.com?subject=${customer && customer.CustomerName} Subscription Expired Help`}>support@breachbits.com</BBExternalLink> to report a problem or &nbsp;
//             <strong style={{textDecoration: "underline"}}>
//                 <Link to={'/board/settings/subscription'}>update your subscription.</Link>
//             </strong>
//         </p>
//
//         {location.pathname.includes("Portfolio") && hasBusinessSubscriptionAccess
//             ? <h3 style={{textDecoration: "underline"}}>
//                 <Link to={"/board/BreachRisk/Business/Score"}>
//                     Go To BreachRisk for Business
//                 </Link>
//             </h3>
//             : location.pathname.includes("Business") && hasPortfolioSubscriptionAccess
//                 ? <h3 style={{textDecoration: "underline"}}>
//                     <Link to={"/board/BreachRisk/Portfolio/Insights"}>
//                         Go To BreachRisk Portfolio
//                     </Link>
//                 </h3>
//                 : <h3>
//                     <BBExternalLink tipText={"Send an email to BreachBits support."} href={`mailto:support@breachbits.com?subject=${customer && customer.CustomerName} Subscription Expired Help`}>Contact Support</BBExternalLink>
//                 </h3>
//         }
//         <h3 id="transition-modal-description">You may still have access to archived data, but be aware that data will only be accurate as of the last time the subscription was active.</h3>

//     </div>
// }
//     customerId={customerInView}
// />